export default {
  FUNDRAISING: 'FUNDRAISING',
  ACTIVE: 'ACTIVE',
  WINDING_DOWN: 'WINDING_DOWN',
  CLOSED: 'CLOSED',
  UPCOMING: 'UPCOMING',
}
